<div class="user-initial">
  {{ initial }}
</div>